export const useGrowniGtag = () => {
    const route = useRoute()

    // Skip tracking for admin and internal pages
    const excludedPaths = ['/admin', '/growni']
    const isExcluded = excludedPaths.some(path => route.path.startsWith(path))
    if (isExcluded) return

    const { gtag, initialize: initializeGtag, disableAnalytics, enableAnalytics } = useGtag()
    const cookieControl = useCookieControl()
    const updateConsent = (granted: boolean) => {
        const newState = granted ? 'granted' : 'denied'
        gtag('consent', 'update', {
            ad_personalization: newState,
            ad_user_data: newState,
            ad_storage: newState,
            analytics_storage: newState
        })
    }
    const enableGtag = () => {
        updateConsent(true)
        initializeGtag()
        enableAnalytics()
    }
    const disableGtag = () => {
        updateConsent(false)
        disableAnalytics()
    }

    if (cookieControl.cookiesEnabledIds.value?.includes('ga')) {
        enableGtag()
    }

    watch(cookieControl.cookiesEnabledIds, (current, previous) => {
        const wasEnabled = previous?.includes('ga')
        const shouldBeEnabled = current?.includes('ga')

        if (wasEnabled === shouldBeEnabled) {
            return
        }

        if (shouldBeEnabled) {
            enableGtag()
        } else {
            disableGtag()
        }
    })
}
